import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { EmojiEvents } from '@mui/icons-material';

import { CustomButton } from '../../../../common/components';
import {
  formatInstallments,
  getPreAdjudicationChipColor,
} from '../../utils/puntajeFormatters';

const SuggestionCard = ({ suggestion, isAdmin, onConfirm, isLoading, title }) => {
  if (!suggestion) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          borderTop: '1px solid',
          borderColor: 'grey.300',
          borderRadius: 0,
          backgroundColor: 'white',
        }}
      >
        <Typography variant="h6" sx={{ mb: 1, backgroundColor: 'white' }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No hay sugerencia activa para este fondo.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'white',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
        <Box sx={{ flex: 1 }}>
          <Stack direction="row" spacing={1} sx={{ mb: 1.5, flexWrap: 'wrap' }}>
            <Chip
              label={suggestion.suggestion_type}
              color={getPreAdjudicationChipColor(suggestion.suggestion_type)}
              size="small"
            />
            {suggestion.fallback_to_ranking ? (
              <Chip label="Cae al ranking" color="warning" size="small" variant="outlined" />
            ) : null}
          </Stack>

          <Typography variant="h6" sx={{ mb: 1 }}>
            {title}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
            Contrato {suggestion.contract_number || '-'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Suscriptor(es): {(suggestion.subscriber_names || []).join(', ') || '-'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Cuotas requeridas: {formatInstallments(suggestion.required_installments)}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Cuotas disponibles: {formatInstallments(suggestion.available_installments)}
          </Typography>
          {suggestion.lottery_full_number ? (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              Numero de loteria: {suggestion.lottery_full_number}
            </Typography>
          ) : null}
          <Typography variant="body2" color="text.secondary">
            {suggestion.reason}
          </Typography>
        </Box>

        <Box sx={{ minWidth: 220 }}>
          <CustomButton
            fullWidth
            variant={isAdmin ? 'base' : 'outlined'}
            buttonIcon={EmojiEvents}
            onClick={onConfirm}
            disabled={!isAdmin || !suggestion.uuid_contract || isLoading}
            isLoading={isLoading}
            sx={{ height: 48 }}
          >
            Preadjudicar
          </CustomButton>
          <Typography variant="caption" sx={{ display: 'block', mt: 1.5, color: 'text.secondary' }}>
            {isAdmin
              ? 'La confirmacion persiste la preadjudicacion y debita el fondo.'
              : 'Solo administradores pueden confirmar la preadjudicacion.'}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};

export default SuggestionCard;
